import type { RouteObject } from "react-router-dom";

import { discreteRoutes } from "./discrete/routes";

export const gamingMechanicsRoutes: Array<RouteObject> = [...discreteRoutes];
